import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation } from "swiper";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";

import "./Work.scss";

const Work = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1080px)");

    setIsMobile(mediaQuery.matches);

    const handleMediaQueryChange = (e) => {
      setIsMobile(e.matches);
    };

    mediaQuery.addEventListener("change", handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
    });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  return (
    <>
      <h2 className="head-text dark:text-slate-50">
        My{" "}
        <span className="dark:text-transparent dark:bg-clip-text dark:bg-gradient-to-r from-[#007991] to-[#78ffd6]">
          Creative Portfolio
        </span>{" "}
        Section
      </h2>

      <div className="app__work-filter">
        {["UI/UX", "Web App", "Mobile App", "React Js", "All"].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex text-black text-[0.8rem] text-left leading-normal 2xl:text-[1.75rem] hover:bg-[#313bac] hover:text-white bg-white dark:hover:bg-darkCyan dark:hover:text-white ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ diration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio w-11/12 relative"
      >
        <div className="absolute hidden sm:block w-[30%] h-[40%] rotate-12 top-52 left-28 dark:bg-[#2188ff] dark:opacity-50 dark:blur-[175px]"></div>
        <Swiper
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={isMobile ? 1 : 4}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 0,
            slideShadows: false,
          }}
          pagination={{ el: ".swiper-pagination", clickable: true }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            clickable: true,
          }}
          modules={[Pagination, Navigation]}
          // breakpoints={{
          //   440: {
          //     slidesPerView: 1,
          //     spaceBetween: 20,
          //   },
          //   640: {
          //     slidesPerView: 2,
          //     spaceBetween: 20,
          //   },
          //   768: {
          //     slidesPerView: 4,
          //     spaceBetween: 40,
          //   },
          //   1024: {
          //     slidesPerView: 5,
          //     spaceBetween: 50,
          //   },
          // }}
          className="relative py-8"
        >
          {filterWork.map((work, index) => (
            <SwiperSlide key={index}>
              <div className="app__work-item app__flex bg-white dark:bg-darkthemealt">
                <div className="app__work-img app__flex">
                  <img
                    src={urlFor(work.imgUrl && work.imgUrl[0])}
                    alt={work.name}
                  />

                  <motion.div
                    whileHover={{ opacity: [0, 1] }}
                    transition={{
                      duration: 0.25,
                      ease: "easeInOut",
                      staggerChildren: 0.5,
                    }}
                    className="app__work-hover app__flex"
                  >
                    {/* Link to project */}
                    <a href={work.projectLink} target="_blank" rel="noreferrer">
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{
                          duration: 0.25,
                          ease: "easeInOut",
                          staggerChildren: 0.5,
                        }}
                        className="app__flex"
                      >
                        <AiFillEye />
                      </motion.div>
                    </a>
                    {/* Link to Code */}
                    <a href={work.codeLink} target="_blank" rel="noreferrer">
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{
                          duration: 0.25,
                          ease: "easeInOut",
                          staggerChildren: 0.5,
                        }}
                        className="app__flex"
                      >
                        <AiFillGithub />
                      </motion.div>
                    </a>
                  </motion.div>
                </div>
                {/* Title & Desc */}
                <div className="app__work-content app__flex">
                  <h4 className="bold-text dark:text-slate-50">{work.title}</h4>
                  <p
                    className="p-text dark:text-slate-300"
                    style={{ marginTop: 10 }}
                  >
                    {work.description}
                  </p>
                  <div className="w-full h-7 items-center flex justify-center gap-2">
                    {work?.imgUrl.slice(1).map((img, index) => (
                      <img
                        key={index}
                        src={urlFor(img)}
                        alt="technologies"
                        className="h-5"
                      />
                    ))}
                  </div>

                  <div className="app__work-tag app__flex">
                    <p className="p-text">{work.tags[0]}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}

          <div className="slider-controler">
            <div className="swiper-button-prev slider-arrow">
              <HiChevronLeft />
            </div>
            <div className="swiper-button-next slider-arrow">
              <HiChevronRight />
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </Swiper>
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg dark:bg-darktheme dark:transition-all"
);
